import React from "react";
import JobTypeCardRouter from "./JobTypeCardRouter";

export default function StandardJob({ job, company }) {
  return (
    <div className="mx-auto max-w-4xl px-4 py-6">
      {/* Header */}
      <div className="flex flex-col gap-1">
        <h1 className="text-2xl font-semibold text-gray-900">
          Job details
        </h1>
        <p className="text-sm text-gray-500">
          {company?.name || job.companyName || "—"}
        </p>
      </div>

      {/* Info card */}
      <div className="mt-4 rounded-xl border border-gray-200 bg-white shadow-sm p-4">
        <h2 className="text-base font-semibold text-gray-800 mb-2">
          Address
        </h2>

        <div className="text-sm text-gray-700">
          {job.address?.line1 || job.address || "—"}
        </div>
      </div>

      {/* Job type card */}
      <div className="mt-6">
        <JobTypeCardRouter job={job} company={company} />
      </div>
    </div>
  );
}
